import IconCmp from '../IconCmp/IconCmp'
import { CloseIcon } from '../../Assets'
import DragNDrop from '../DragNDrop/DragNDrop'
import styles from './ImgModal.module.css'
import WhiteButtonCmp from '../ButtonCmp/WhiteButtonCmp'
import ButtonCmp from '../ButtonCmp/ButtonCmp'
import Backdrop from '@mui/material/Backdrop'

import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import Avatar from 'react-avatar-edit'
import Cropper from 'react-easy-crop'
import { useEffect, useCallback, useState } from 'react'
import { dataURLtoFile } from '../../Utils/dataURLtofile'
import {
    UpdateProfilePicAction,
    UpdateCoverPicAction
} from '../../Store/Actions/ProfileAction'
import useAlert from '../../Hooks/useAlert/useAlert'
import getCroppedImg from '../../Utils/getCroppedImg'
import { useDispatch, useSelector } from 'react-redux'
import { CloudUpload, Upload } from '@mui/icons-material'
import ActionTypes from '../../Store/Constants'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    outline: 'none !important',
    p: 4,
}

export default function ImgModal({
    open,
    setOpen,
    getImages,
    setGetImages,
    isCover,
    coverImage,
    isProfile,
    profileImage
}) {
    const [imgCrop, setImgCrop] = useState(false)

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const [coverImg, setCoverImg] = useState(null);
    const [profileImg, setProfileImg] = useState(null);

    const { setAlert } = useAlert()
    const dispatch = useDispatch()

    const handleClose = () => { setOpen(false); setCoverImg(null); setProfileImg(null); setZoom(1); setCrop({ x: 0, y: 0 })}
    const { UpdateProfileLoading } = useSelector(
        (state) => state.UpdateProfileReducer
    )
    const { UpdateCoverLoading } = useSelector(
        (state) => state.UpdateCoverReducer
    )
    const onCrop = (view) => {
        setImgCrop(view)
    }

    const onClose = () => {
        setImgCrop(null)
    }

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }, [])

    const savaImage = async () => {
        let fileName;
 debugger
        if (isCover) {
            dispatch({
                type: ActionTypes.UPDATE_COVER_REQUEST,
            })
            const croppedImage = await getCroppedImg(coverImg, croppedAreaPixels)
            fileName = dataURLtoFile(croppedImage, 'cover-photo.png')
        } else if (isProfile) {
            dispatch({
                type: ActionTypes.UPDATE_PROFILE_REQUEST,
            })
            const croppedImage = await getCroppedImg(profileImg, croppedAreaPixels)
            fileName = dataURLtoFile(croppedImage, 'profile-photo.png')
        }
        else {
            fileName = dataURLtoFile(imgCrop, 'profile-photo.png')
        }

        setGetImages(fileName)
        await dispatch(
            isCover
                ? UpdateCoverPicAction(fileName, 'coverPic', setAlert, setOpen)
                : UpdateProfilePicAction(fileName, 'profilePic', setAlert, setOpen)
        );

        handleClose()

    }

    useEffect(() => {
        if (isCover) {
            setCoverImg(coverImage);
        } else if (isProfile) {
            setProfileImg(profileImage);
        }
        return () => {
            setCoverImg(null);
            setProfileImg(null);
        }
    }, [isCover, coverImage, isProfile, profileImage]);

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500 }}
            >
                <Box sx={style}>
                    {/* Header */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant={'h6'}>
                            Upload {isCover ? 'Cover' : 'Profile'} Image
                        </Typography>
                        <IconCmp>
                            <CloseIcon onClick={handleClose} />
                        </IconCmp>
                    </Box>

                    {/* Body */}
                    <Box className={styles.modalBody}>
                        {isCover ? (
                            coverImg ? (
                                <div style={{ position: "relative", width: "100%", height: 400 }}>
                                    <Cropper
                                        
                                        image={coverImg}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={16 / 9}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                            ) : (
                                <div className={styles.dropZoneContainer}>
                                    <input
                                        type="file"
                                        id="coverImageInput"
                                        accept="image/*"
                                        onChange={(e) => setCoverImg(URL.createObjectURL(e.target.files[0]))}
                                        className={styles.fileInput}
                                    />

                                    <label htmlFor="coverImageInput" className={styles.dropZoneLabel}>
                                        {"Choose a file"}
                                    </label>
                                </div>
                            )
                        ) : isProfile ? (
                            profileImg ? (
                                <div style={{ position: "relative", width: "100%", height: 400 }}>
                                    <Cropper
                                        image={profileImg}
                                        crop={crop}
                                        zoom={zoom}

                                        aspect={1}
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                            ) : (
                                <div className={styles.dropZoneContainer}>
                                    <input
                                        type="file"
                                        id="profileImageInput"
                                        accept="image/*"
                                        onChange={(e) => setProfileImg(URL.createObjectURL(e.target.files[0]))}
                                        className={styles.fileInput}
                                    />

                                    <label htmlFor="profileImageInput" className={styles.dropZoneLabel}>
                                        {"Choose a file"}
                                    </label>
                                </div>
                            )
                        ) : (
                            <Avatar
                                width={'100%'}
                                height={400}
                                onCrop={onCrop}
                                onClose={onClose}
                                minCropRadius={80}
                                cropRadius={80}
                            />
                        )}
                        {/* 
                           {isCover ? (
                            coverImg ? (
                                <div style={{ position: "relative", width: "100%", height: 400 }}>
                                    <Cropper
                                        image={coverImg}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={16 / 9} // Cover photo aspect ratio
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                            ) : (
                                
                                <div className={styles.dropZoneContainer}>
                                    <input
                                        type="file"
                                        id="coverImageInput"
                                        accept="image/*"
                                        onChange={(e) => setCoverImg(URL.createObjectURL(e.target.files[0]))}

                                        className={styles.fileInput}
                                    />

                                    <label htmlFor="coverImageInput" className={styles.dropZoneLabel}>
                                        {"Choose a file"}
                                    </label>
                                </div>
                            )
                        ) : (
                            <Avatar
                                width={'100%'}
                                height={400}
                                onCrop={onCrop}
                                onClose={onClose}
                                minCropRadius={80}
                                cropRadius={80}
                            />
                        )} */}
                    </Box>

                    {/* Footer */}
                    <Box sx={{ display: 'flex', justifyContent: coverImg && isCover || profileImg && isProfile ? 'space-between' : 'end', alignItems: 'center' }}>
                        {coverImg && isCover && <Box>
                            <input
                                type="file"
                                id="coverImageInputFooter"
                                accept="image/*"
                                onChange={(e) => setCoverImg(URL.createObjectURL(e.target.files[0]))}
                                className={styles.fileInput}
                            />
                            <label htmlFor="coverImageInputFooter" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', backgroundColor: '#f4f4f4', padding: '10px 20px', borderRadius: 50, border: '1px solid grey' }}>
                                {"Browse"} <CloudUpload />
                            </label>
                        </Box>}
                        {profileImg && isProfile && <Box>
                            <input
                                type="file"
                                id="profileImageInputFooter"
                                accept="image/*"
                                onChange={(e) => setProfileImg(URL.createObjectURL(e.target.files[0]))}
                                className={styles.fileInput}
                            />
                            <label htmlFor="profileImageInputFooter" style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', backgroundColor: '#f4f4f4', padding: '10px 20px', borderRadius: 50, border: '1px solid grey' }}>
                                {"Browse"} <CloudUpload />
                            </label>
                        </Box>}
                        <Box className={''} sx={{ display: 'flex', gap: 2 }}>
                            <WhiteButtonCmp title="Cancel" onClick={handleClose} />
                            <ButtonCmp onClick={savaImage} title={UpdateCoverLoading || UpdateProfileLoading ? "Loading..." : "Save"} disabled={UpdateCoverLoading || UpdateProfileLoading} />
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

// import IconCmp from '../IconCmp/IconCmp'
// import { CloseIcon } from '../../Assets'
// import DragNDrop from '../DragNDrop/DragNDrop'
// import styles from './ImgModal.module.css'
// import WhiteButtonCmp from '../ButtonCmp/WhiteButtonCmp'
// import ButtonCmp from '../ButtonCmp/ButtonCmp'
// import Backdrop from '@mui/material/Backdrop'

// import * as React from 'react'
// import Box from '@mui/material/Box'
// import Button from '@mui/material/Button'
// import Typography from '@mui/material/Typography'
// import Modal from '@mui/material/Modal'
// import Avatar from 'react-avatar-edit'
// import Pic1 from '../../Assets/Images/BuildLinkCompleteLogo.png'
// import { useEffect } from 'react'
// import { dataURLtoFile } from '../../Utils/dataURLtofile'
// import { useDispatch } from 'react-redux'
// import {
//     UpdateProfileAction,
//     UpdateProfilePicAction,
//     UpdateCoverPicAction
// } from '../../Store/Actions/ProfileAction'
// import useAlert from '../../Hooks/useAlert/useAlert'

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 700,
//     bgcolor: 'background.paper',
//     border: 'none',
//     boxShadow: 24,
//     outline: 'none !important',
//     p: 4,
// }

// export default function ImgModal({
//     open,
//     setOpen,
//     getImages,
//     setGetImages,
//     getImagesFucntion,
//     isCover
// }) {
//     //   const [getImage, setGetImage] = React.useState(false);
//     //   const [profileImgSrc, setProfileImgSrc] = React.useState(false);
//     const [imgCrop, setImgCrop] = React.useState(false)
//     const [storeImg, setStoreImg] = React.useState([])

//     // const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false)

//     const onCrop = (view) => {
//         setImgCrop(view)
//     }

//     const onClose = () => {
//         setImgCrop(null)
//     }

//     const savaImage = () => {
//         setStoreImg([...storeImg, { imgCrop }])
//     }
//     const { setAlert } = useAlert()
//     const distpatch = useDispatch()

//     useEffect(() => {
//         if (storeImg.length > 0) {
//             const fileName = dataURLtoFile(
//                 storeImg[0].imgCrop,
//                 'croping-img.png'
//             )
//             console.log(fileName, 'fileName')
//             setGetImages(fileName)
//             distpatch(
//                 isCover ? UpdateCoverPicAction(
//                     fileName,
//                     'coverPic',
//                     setAlert,
//                     setOpen
//                 ) :
//                     UpdateProfilePicAction(
//                         fileName,
//                         'profilePic',
//                         setAlert,
//                         setOpen
//                     )
//             )
//         }
//     }, [storeImg])

//     return (
//         <div>
//             <Modal
//                 aria-labelledby="transition-modal-title"
//                 aria-describedby="transition-modal-description"
//                 open={open}
//                 onClose={handleClose}
//                 closeAfterTransition
//                 BackdropComponent={Backdrop}
//                 BackdropProps={{
//                     timeout: 500,
//                 }}
//             >
//                 <Box sx={style}>
//                     {/* ///header/// */}
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                         }}
//                     >
//                         <Typography variant={'h6'}>Upload {isCover && 'Cover'} Image</Typography>

//                         <IconCmp>
//                             <CloseIcon onClick={handleClose} />
//                         </IconCmp>
//                     </Box>

//                     {/* ///BODY/// */}
//                     <Box className={styles.modalBody}>
//                         {/* {!profileImgSrc && (
//               <Box className={styles.imageuploadBox}>
//                 <DragNDrop
//                   images={true}
//                   setImageSrc={setProfileImgSrc}
//                   getFile={setGetImage}
//                 />
//               </Box>
//             )} */}
//                         {/* {profileImgSrc && <img src={profileImgSrc} alt="pic" />} */}
//                         <Avatar
//                             width={'100%'}
//                             height={400}
//                             onCrop={onCrop}
//                             onClose={onClose}
//                             minCropRadius={80}
//                             cropRadius={80}
//                         />
//                     </Box>

//                     {/* ///footer// */}
//                     <Box className={styles.footerModal}>
//                         <WhiteButtonCmp title="cancel" onClick={handleClose} />
//                         <ButtonCmp onClick={savaImage} title="Save" />
//                     </Box>
//                 </Box>
//             </Modal>
//         </div>
//     )
// }
